import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Products from '@/views/Products'
import About from '@/views/About'
import Details from '@/views/Details'
import Exception404 from '@/views/exception/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        title: 'Products | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/about',
      name: 'About Us',
      component: About,
      meta: {
        title: 'About Us | Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: Details,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/products/:name',
      name: 'Details',
      component: Details,
      meta: {
        title: 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    {
      path: '/404',
      name: '404',
      component: Exception404,
      meta: {title: '404'}
    },
    {
      path: '*', redirect: '/404', hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js